import React from 'react';
import OeTip from './OeTip';
import {lockReason} from './wizard';

/**
 * Sperrbanner für stornierte, abgeschlossene oder manuell geschlossene
 * Aufträge (Original `renderLocked`, 3277–3286; ABGLEICH E42, G45).
 *
 * Der Aufrufer blendet zusätzlich Wizard, Tabelle, Filterleiste und Add-Zeile
 * aus — hier gibt es nichts zu tun. Ansehen bleibt möglich: Kopfdaten,
 * Kundeninfo und die Belege/PDFs.
 */
export default function LockBar({ctx}) {
    const order = ctx.order;

    return (
        <div className="lockbar" role="status">
            <span className="lockico" aria-hidden="true">🔒</span>
            <span className="lockmain">
                <span className="locktitle">
                    Dieser Auftrag ist {lockReason(ctx)} — hier gibt es nichts zu tun.
                </span>
                <span className="lockdesc">
                    Der Auftrag lässt sich in der Schnellerfassung <b>nicht bearbeiten</b>: keine Lieferung, keine
                    Bestandsbuchung, keine Rabatte, kein Speichern. Ansehen kannst du alles — Kopfdaten, Kundeninfo
                    und die Belege/PDFs. Zum Bearbeiten müsste er in weclapp wieder geöffnet werden.
                </span>
            </span>
            {order && order.webUrl ? (
                <OeTip tip="Öffnet den Auftrag in weclapp in einem neuen Browser-Tab — dort lässt er sich wieder öffnen.">
                    <a className="wl" href={order.webUrl} target="_blank" rel="noopener noreferrer">
                        in weclapp öffnen ↗
                    </a>
                </OeTip>
            ) : null}
        </div>
    );
}
